import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {fetchCaseSelection, fetchCaseList} from './../actions/CaseActions';

const CaseSlice = createSlice({
  name: 'case',
  initialState: {
    caseSelection: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
    caseList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCaseSelection.pending, (state) => {
        state.caseSelection.status = 'loading';
      })
      .addCase(fetchCaseSelection.fulfilled, (state, action) => {
        state.caseSelection.status = 'idle';
        state.caseSelection.data = action.payload.result;
      })
      .addCase(fetchCaseSelection.rejected, (state, action) => {
        state.caseSelection.status = 'rejected';
        state.caseSelection.error = action.error.message;
      })

      .addCase(fetchCaseList.pending, (state) => {
        state.caseList.status = 'loading';
      })
      .addCase(fetchCaseList.fulfilled, (state, action) => {
        state.caseList.status = 'idle';
        state.caseList.data = action.payload.result;
      })
      .addCase(fetchCaseList.rejected, (state, action) => {
        state.caseList.status = 'rejected';
        state.caseList.error = action.error.message;
      });
  },
});

export default CaseSlice.reducer;
